// Shared speaker-name color palette (dark/light safe). Keys are what we store in user prefs and
// pass around via presence; values are the Tailwind text classes used to color a speaker's name
// in the transcript. Used by both the transcript (RoomPage) and the Settings color picker.

export const NAME_COLORS: Record<string, string> = {
  brand: "text-brand-600 dark:text-brand-400",
  emerald: "text-emerald-600 dark:text-emerald-400",
  violet: "text-violet-600 dark:text-violet-400",
  amber: "text-amber-600 dark:text-amber-400",
  rose: "text-rose-600 dark:text-rose-400",
  sky: "text-sky-600 dark:text-sky-400",
  teal: "text-teal-600 dark:text-teal-400",
  fuchsia: "text-fuchsia-600 dark:text-fuchsia-400",
};

// Literal bg classes for the Settings swatches (Tailwind can't see runtime-built class names).
export const NAME_SWATCHES: Record<string, string> = {
  brand: "bg-brand-600",
  emerald: "bg-emerald-600",
  violet: "bg-violet-600",
  amber: "bg-amber-600",
  rose: "bg-rose-600",
  sky: "bg-sky-600",
  teal: "bg-teal-600",
  fuchsia: "bg-fuchsia-600",
};

export const COLOR_KEYS = Object.keys(NAME_COLORS);

/** Deterministic fallback color key for a name (stable per name, so people stay one color). */
export function hashColorKey(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return COLOR_KEYS[h % COLOR_KEYS.length];
}

/** A speaker's name-color class: a valid custom key (from their prefs) wins; else hashed. */
export function speakerColorClass(name: string, customKey?: string | null): string {
  const key = customKey && NAME_COLORS[customKey] ? customKey : hashColorKey(name);
  return NAME_COLORS[key];
}
